import { openDB, deleteDB } from 'idb/with-async-ittr.js';

const dbPromise = () => openDB('ColetorDB', 5, {
  upgrade(db, oldVersion) {
    /* eslint-disable no-fallthrough */
    switch(oldVersion) {
      case 0:
        // Create a store of objects
        var pedidosOS = db.createObjectStore('saidas', {
          // The 'id' property of the object will be the key.
          keyPath: 'id_saida'
        });
        // Create an index on the 'date' property of the objects.
        pedidosOS.createIndex('emissao', 'emissao');
      case 1:
        var producoesOS = db.createObjectStore('producoes', {
          keyPath: 'id_producao'
        });
        producoesOS.createIndex('emissao', 'emissao');
      case 2:
        var balancosOS = db.createObjectStore('balancos', {
          keyPath: 'id_balanco'
        });
        balancosOS.createIndex('emissao', 'emissao');
      case 3:
        db.createObjectStore('unidades', {
          keyPath: 'id_unidade'
        });
      case 4:
        var requisicoesOS = db.createObjectStore('requisicoes', {
          keyPath: 'id_interno',
          autoIncrement: true
        });
        // Create an index on the 'id_requisicao' property of the objects.
        requisicoesOS.createIndex('id_requisicao', 'id_requisicao');
        requisicoesOS.createIndex('id_producao', 'id_producao');
        requisicoesOS.createIndex('data_emissao', 'data_emissao');
    }
  },
});

async function addToStore(storeName, obj) {
  const db = await dbPromise(storeName);
  return db.add(storeName, obj);
}

async function updateItem(storeName, obj) {
  const db = await dbPromise(storeName);
  await db.put(storeName, obj);
}

async function addMultipleToStore(storeName, array) {
  const db = await dbPromise(storeName);

  for (const item of array) {
    await db.add(storeName, item);
  }
}

async function getAll(storeName) {
  const db = await dbPromise(storeName);
  return db.getAll(storeName);
}

async function getAllFromIndex(storeName, indexName, query = undefined) {
  const db = await dbPromise(storeName);
  return db.getAllFromIndex(storeName, indexName, query);
}

async function getFromIndex(storeName, indexName, id) {
  const db = await dbPromise(storeName);
  return db.getFromIndex(storeName, indexName, Number(id));
}

async function getAllKeysFromIndex(storeName, indexName, id) {
  const db = await dbPromise(storeName);
  return db.getAllKeysFromIndex(storeName, indexName, Number(id));
}

async function getById(storeName, id) {
  const db = await dbPromise(storeName);
  return db.get(storeName, Number(id));
}

async function deleteFromStore(storeName, key) {
  const db = await dbPromise(storeName);
  return db.delete(storeName, key);
}

async function clearStore(storeName) {
  const db = await dbPromise(storeName);
  return db.clear(storeName);
}

function destroyDb() {
  return deleteDB('ColetorDB');
}

export default {
  addToStore,
  updateItem,
  addMultipleToStore,
  getAll,
  getAllFromIndex,
  getAllKeysFromIndex,
  getFromIndex,
  getById,
  deleteFromStore,
  clearStore,
  destroyDb
}